<template>
  <div class="training-video section">
    <div class="layout-content">
      <SubTitle :text="title" :subText="subText" />

      <div class="content">
        <div class="content-list" v-for="(item, index) in data.list" :key="index">
          <a :href="item.video" target="_blank">
            <div class="content-img-wrap">
              <img class="content-img" :src="item.imgUrl" alt="视频图片">
            </div>
            <div class="content-wrapper">
              <p class="content-title">{{item.contentText}}</p>
            </div>
          </a>
        </div>
      </div>

      <a v-if="data.buttonLink" class="bottom-button" :href="data.buttonLink" target="_blank">
        {{data.buttonText}}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import SubTitle from '@/components/SubTitle.vue'
// import TriningList from '@/components/TrainingList.vue'

import VueTypes from 'vue-types'

export default {
  name: 'training-video',
  components: {
    SubTitle
    // TriningList
  },
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'isEnLang']),

    title () {
      return this.isEnLang ? 'Training Videos' : '培训视频'
    },

    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'FINTECHATHON'
    }
  },
  created () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>

.training-video {
  padding-bottom: 120px;
  background: #F7F8FA;

  @include mobile {
    padding-bottom: 50px;
  }
}

.content {
  display: flex; justify-content: space-between;

  @include mobile {
    // margin-top: -6px;
    justify-content: space-between; flex-wrap: wrap;
  }
}

.content-list {
  position: relative;
  margin: 0 24px 27px 0;

  @include mobile {
    margin: 0;
  }

  &:nth-child(4n+4) {
    margin-right: 0;
  }

  @include mobile {
    width: calc(calc(100% - 15px) / 2);
    margin: 0 15px 26px 0;

    &:nth-child(3n+3) {
      margin-right: 15px;
    }
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}

.content-img {
  width: 285px; height: 160px;
  margin-bottom: 18px;

  @include mobile {
    width: 100%; height: auto;
    margin-bottom: 8px;
  }
}

.content-img-wrap {
  position: relative;
  &::before {
    content: "";
    position: absolute; top: 50%; left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 40px; height: 40px;
    background: url('~@/assets/transSave/resource/image/ef/69/efd0026a21de3da79eb68b8cb8a07969.png') center / cover no-repeat;

    @include mobile {
      width: 24px; height: 24px;
    }
  }
}

.content-wrapper {
  // width: 258px; height: 112px;
  // padding: 24px 36px;
  // background: #FFFFFF;

  &:hover {
    .content-title {
      color: #376EFD;
    }
  }

  @include mobile {
    width: auto; height: auto;
    padding: 8px 0 0 0;
    background: transparent;
  }
}

.content-title {
  color: #000000;
  font-size: 16px; font-weight: 600;
  line-height: 30px;
  @include row(2);

  @include mobile {
    font-size: 13px; font-weight: 500;
    line-height: 21px;
  }
}

.bottom-button {
  display: flex; justify-content: center; align-items: center;
  box-sizing: border-box;
  width: 182px; height: 44px;
  margin: 13px auto 0;
  opacity: 0.9;
  border: 1px solid #000000;
  font-size: 14px; font-weight: 500;
  color: #000000;
  line-height: 44px;

  &:hover {
    background: #000000;
    color: #FFFFFF;
    opacity: 0.9;
  }

  @include mobile {
    width: fit-content;
    height: 36px;
    padding: 0 20px;
    font-size: 14px;
    line-height: 36px;
  }
}
</style>
